import { Box } from '@/components/ui/lib/box';
import { Flex } from '@/components/ui/lib/flex';
import { HStack } from '@/components/ui/lib/hstack';
import { Image } from '@/components/ui/lib/image';
import { Link } from '@/components/ui/lib/link';
import AuthConsoleControl from '@/app/components/auth-console-control';
import ColorModeToggleButton from '@/app/components/color-mode-toggle-button';
import { DICTIONARY } from '@/config/dictionary';
import { env } from '@/config/env';
import { APP_PATHS } from '@/config/routes/app-paths';
import { useAppStore } from '@/stores/app-store';
import { ensureValidPath } from '@/utils/validate-path';

const Navbar = () => {
  const colorMode = useAppStore((s) => s.colorMode);
  const logoSrc =
    colorMode === 'dark' && env.VITE_LOGO_URL_DARK ? env.VITE_LOGO_URL_DARK : env.VITE_LOGO_URL;

  return (
    <Box
      as="header"
      position="sticky"
      top="0"
      zIndex="50"
      paddingLeft={5}
      paddingRight={5}
      className="bg-nav border-b border-rim"
    >
      <Flex mx="auto" maxW="8xl" h="72px" align="center" justify="space-between">
        {/* Logo */}
        <Link href={ensureValidPath(APP_PATHS.home)} _hover={{ textDecoration: 'none' }}>
          <Image src={logoSrc} alt={DICTIONARY.brand.full} h="8" />
        </Link>

        {/* Nav links */}
        <HStack
          as="nav"
          gap="8"
          fontSize="sm"
          fontWeight="medium"
          display={{ base: 'none', md: 'flex' }}
          className="text-muted"
        >
          {DICTIONARY.nav.links.map((link) => (
            <Link
              key={link.href}
              href={link.href}
              color="inherit"
              _hover={{ textDecoration: 'none' }}
              className="transition-colors hover:text-base"
            >
              {link.label}
            </Link>
          ))}
        </HStack>

        {/* Right controls */}
        <HStack gap="3">
          <ColorModeToggleButton />
          <AuthConsoleControl />
        </HStack>
      </Flex>
    </Box>
  );
};

export default Navbar;
